import React from "react";
import ReactDOM from "react-dom/client";
import CustomForm from "./pages/CustomFormPage/customForm";
import { IntlProvider } from 'react-intl';
import { loadLocale } from "./locale";
import { MemoryRouter } from "react-router-dom";

// 全局挂载，宿主可以直接调用
window.CustomFormRuntime = {
    mount: (container, props = {}) => {
        if (!container) {
            console.error("CustomFormRuntime.mount: container is required");
            return;
        }
        const { locale, antdLocale, message } = loadLocale('global');

        ReactDOM.createRoot(container).render(
            <MemoryRouter initialEntries={[window.location.pathname]}>
                <IntlProvider locale={locale} messages={message} onError={()=>{}}>
                    <CustomForm {...props} />
                </IntlProvider>
            </MemoryRouter>
        );
    },
};